
  document.addEventListener('DOMContentLoaded', function () {
    
    const swiper = new Swiper('.swiper-container', {
      slidesPerView: 5, // Adjust based on the desired visible slides
      spaceBetween: 10,
      navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });
